import React from 'react';
// import Dropdown from 'react-bootstrap/Dropdown'

import { Roles } from '../../../api/types';
import { Form } from 'react-bootstrap';


interface RoleDropdownProps {
  className?: string
  role: Roles
  setRole: (
    value: Roles
  ) => void
  disabled?: boolean
}

const RoleDropdown = ( props: RoleDropdownProps ) => {
  const onFormChange = (e: any) => {
    e.persist();
    props.setRole(e.target.value as Roles);
  }

  return props.role === 'Owner'
  ? <span>Owner{' '} <i className='modus-icons' style={{ verticalAlign: 'bottom' }}>lock</i></span>
  : (
    <Form.Control as="select" onChange={onFormChange} value={props.role} className={props.className} disabled={props.disabled}>
      <option value="Viewer">Viewer</option>
      <option value="Editor">Editor</option>
    </Form.Control>
  )
}

export default RoleDropdown;